import styled from '@emotion/styled'
export const StyleEmptyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 10px;
  width: 100%;
  height: 100%;
  flex: 1;
`
export const StyleSvgWrapper = styled.div<any>`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors[props.color || 'black']};
  svg {
    width: ${(props) => props.size || 20}px;
    height: ${(props) => props.size || 20}px;
  }
`
